import type { ReactNode } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import type { NodePath } from '@/components/tree-dnd/tree-dnd-types';
import { encodeItemId } from '@/components/tree-dnd/tree-dnd-path';
import { cn } from '@/lib/utils';

interface TreeDndSortableProps {
  path: NodePath;
  disabled?: boolean;
  className?: string;
  children: (props: {
    isDragging: boolean;
    dragHandleProps: {
      listeners: ReturnType<typeof useSortable>['listeners'];
      attributes: ReturnType<typeof useSortable>['attributes'];
    };
  }) => ReactNode;
}

export function TreeDndSortable({
  path,
  disabled,
  className,
  children,
}: TreeDndSortableProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useSortable({
    id: encodeItemId(path),
    disabled,
    animateLayoutChanges: () => false,
  });

  return (
    <div
      ref={setNodeRef}
      className={cn(className, isDragging && 'pointer-events-none opacity-0')}
    >
      {children({
        isDragging,
        dragHandleProps: { listeners, attributes },
      })}
    </div>
  );
}
